export default "__VITE_ASSET__PdRLwhP5__"